var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoMutedRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.625 43.5H13.2917C10.6333 43.5 8.45833 41.325 8.45833 38.6667V19.3333C8.45833 16.675 10.6333 14.5 13.2917 14.5H32.625C35.2833 14.5 37.4583 16.675 37.4583 19.3333V38.6667C37.4583 41.325 35.2833 43.5 32.625 43.5Z",
    stroke: "#D4343E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4583 32.625L47.6083 39.7541C48.4542 40.3583 49.5417 39.7541 49.5417 38.7875V19.2125C49.5417 18.2458 48.4542 17.6416 47.6083 18.2458L37.4583 25.375V32.625Z",
    stroke: "#D4343E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.975 8.45837L9.66667 49.6625",
    stroke: "#D4343E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoMutedRed);
export default __webpack_public_path__ + "static/media/video-muted-red.fc55a048559fff508c05c92b2d45016b.svg";
export { ForwardRef as ReactComponent };